import { RoleResponse } from "@/models/role/RoleResponse";
import { useRoleStore } from "@/store/Role";
import { computed, onMounted } from "vue";

export function useCan() {
    const roleStore = useRoleStore();
    onMounted(async () => await roleStore.getAll());

    const databaseRoles = computed(() => roleStore.roles);

    return {
        databaseRoles,
    };
}

export function hasRoleAccess(roleCode: number): boolean {
    const currentRole = getCurrentUserRole();
    return currentRole?.code === roleCode;
}

function getCurrentUserRole(): RoleResponse | null {
    const fromRole = readRole(localStorage.getItem("role"));
    if (fromRole) return fromRole;

    return readRoleFromUser(localStorage.getItem("user"));
}

function readRole(raw: string | null): RoleResponse | null {
    if (!raw || raw === "null" || raw === "undefined") return null;
    try {
        return parseRole(JSON.parse(raw));
    } catch (error) {
        console.error("Invalid role JSON:", error);
        return null;
    }
}

function readRoleFromUser(raw: string | null): RoleResponse | null {
    if (!raw || raw === "null" || raw === "undefined") return null;
    try {
        const user = JSON.parse(raw);
        return parseRole(user?.role);
    } catch {
        return null;
    }
}

function parseRole(jsonRole: any): RoleResponse | null {
    if (!jsonRole || typeof jsonRole !== "object") return null;
    if (jsonRole.code === null || jsonRole.code === undefined) return null;
    return {
        id: jsonRole.id,
        name: jsonRole.name,
        code: jsonRole.code,
    };
}
